import { useState, useEffect } from "react";
import Link from "next/link";
import nextCookie from "next-cookies";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faShoppingCart } from "@fortawesome/free-solid-svg-icons";
import { toast } from "react-toastify";
import cookie from "js-cookie";
import { LazyLoadImage } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/blur.css';

import QuantitySelector from "../QuantitySelector";
import Icon from "../Icon";

import { useCart } from "../CartContext";
import { useUser } from "../UserContext";
import * as fbq from '../../lib/fpixel'
import { cartApi } from "../../services/api";

import {
  ProductItem,
  ProductName,
  ProductImage,
  ProductSku,
  ProductPrice,
  ProductTax,
  QuantityChanger,
  AddButton,
  ProductTag,
  SoldOut,
  FlagImage,
  AddButtonSouv
} from "./styles";

export default ({ product, clean, cart_token }) => {
  const [quantity, setQuantity] = useState(1);
  const [userToken, setUserToken] = useState();
  const [cartToken, setCartToken] = useState(cart_token);
  const { setCart } = useCart();
  const { user } = useUser();
  var link_product = `/produtos/${product.slug}`;
  var href_product = `/produtos/[slug]`;
  if (typeof window !== "undefined") {
    if (window.location.href.includes("souvenirs")) {
      link_product = `/souvenirs/${product.sku}`;
      href_product = `/souvenirs/[slug]`;
    } else {
      link_product = `/produtos/${product.slug}`;
      href_product = `/produtos/[slug]`;
    }
  }
  useEffect(() => {
    const { token, souv_token, souvenir } = nextCookie();
    if (souvenir == 1) {
      setUserToken(souv_token);

    } else {
      setUserToken(token);

    }
  }, []);

  const currency_br = new Intl.NumberFormat("pt-BR", {
    style: "currency",
    currency: "BRL"
  });
  const currency_eua = new Intl.NumberFormat("pt-BR", {
    style: "currency",
    currency: "USD"
  });

  function handleChange(e) {
    e.preventDefault();

    setQuantity(e.target.value);
  }
  var moeda;
  function goToCart() {
    if (cookie.get('souvenir') == 1) {
      window.location.href = "/carrinho?souv=1";
    } else {
      window.location.href = "/carrinho";
    }
  }
  async function handleSubmit(e) {
    e.preventDefault();
    { user && user.ex ? moeda = 'USD' : moeda = 'BRL' }
    fbq.addtocart(product, moeda);
    const newCart = await cartApi.add(product.id, quantity, 0, 0, {
      user_token: userToken,
      cart_token: cookie.get("cart_token")
    });

    cookie.set("cart_token", newCart['id'] ?? "", { expires: 30 });
    // debugger;
    setCartToken(newCart['id']);
    setCart(newCart['items']);

    toast.success("Produto adicionado no Carrinho!",
      {
        position: "bottom-left",
        autoClose: 5000,
        closeOnClick: true,
        pauseOnHover: true,
        onClick: function () { goToCart() }
      });
  }
  return (
    <ProductItem cart_token={cart_token} clean={clean} withPrice={!!product.price}>

      {(product.origin ?
        <FlagImage><img src="/feito-no-brasil-goods-br.png" /></FlagImage>
        : ""
      )}
      {/* <FlagImage><img src="/feito-no-brasil-goods-br-sem-fundo.png" /></FlagImage> */}
      <Link href={href_product} as={link_product}>
        <a>
          {parseFloat(product.oldprice) > parseFloat(product.price) && product.stock ? (
            <ProductTag><span>{(((parseFloat(product.oldprice) - parseFloat(product.price)) * 100) / parseFloat(product.oldprice)).toFixed(0)}% OFF</span></ProductTag>) : ""}

          <ProductImage>
            <LazyLoadImage
              effect="blur"
              max-height="224px"
              src={product.images[0] || "/no-image.jpg"}
              alt={product.name}
            />
          </ProductImage>
          <ProductName>{product.name}</ProductName>
          <ProductSku>Ref: {product.sku}</ProductSku>

          {(user && !product.stock && !product.partner_brands && !product.sale_out_stock && !((!user || user.profile == "costumer") && product.sale_out_stock_customer) && !((!user || user.profile == "corporate") && product.sale_out_stock_corporate)) && (
            <SoldOut >Esgotado</SoldOut>
          )
          }


          {(user && product.partner_brands && !product.sale_out_stock && ((!user || user.profile == "costumer") && !product.sale_out_stock_customer) && ((user && user.profile == "corporate") && !product.sale_out_stock_corporative)) && (
            <SoldOut >Sob consulta</SoldOut>
          )
          }



          {(user) || (cookie.get('souvenir') == 1)?
          ((!product.partner_brands && product.price && product.stock) || product.sale_out_stock || (!user || user.profile == "costumer") && product.sale_out_stock_customer || (user && user.profile == "corporate") && product.sale_out_stock_corporative) && (
            <div>
              {parseFloat(product.oldprice) > parseFloat(product.price) ? (
                <>
                  De {user && user.ex ? currency_eua.format(product.oldprice) : currency_br.format(product.oldprice)}
                  <br />
                  <ProductPrice>
                    Por {user && user.ex ? currency_eua.format(product.price) : currency_br.format(product.price)}
                  </ProductPrice>
                </>
              ) : (
                <ProductPrice>
                  {user && user.ex ? currency_eua.format(product.price) : currency_br.format(product.price)}
                  {product.unity == "M2" && <span>m²</span>}
                </ProductPrice>
              )}
              {(product.tax > 0 && !user?.vip && user?.profile == "shopkeeper" && !user.ex) && (
                <ProductTax>+ {product.tax}% de IPI</ProductTax>
              )}

              {(user && user?.profile != "costumer" && product.min_amount) ? (<div><span>Valor da caixa com {product.min_amount} UN</span></div>) : ""}
            </div>
          )
          :
          ''}



          {(user && !product.partner_brands && product.delivery_at && !product.stock) &&
            <>
              <ProductSku>
                <span Style="color: black;"><strong>Entrega prevista após: {product.delivery_at}</strong></span>
              </ProductSku>
            </>
          }

          {(user && !product.delivery_at && product.manufacturing_time && product.stock == false) &&
            <>
              <ProductSku>
                <span Style="color: black;"><strong>Tempo de produção: {product.manufacturing_time} dias</strong></span>
              </ProductSku>
            </>
          }




        </a>
      </Link>
      {(!product.partner_brands && product.price && product.stock && !user?.vip && product.unity != "M2" || product.unity != "M2" && product.sale_out_stock || product.unity != "M2" && ((!user || user.profile == "costumer") && product.sale_out_stock_customer) || product.unity != "M2" && ((user && user.profile == "corporate") && product.sale_out_stock_corporative)) && (
        (user) || (cookie.get('souvenir') == 1) ?
        <QuantityChanger>
          <QuantitySelector value={quantity} onChange={handleChange} />
          {(cookie.get('souvenir') == 1 ?
            <AddButtonSouv onClick={handleSubmit}>
              <Icon size="20">
                <FontAwesomeIcon icon={faShoppingCart} />
              </Icon>
            </AddButtonSouv>
            :
            <AddButton onClick={handleSubmit}>
              <Icon size="20">
                <FontAwesomeIcon icon={faShoppingCart} />
              </Icon>
            </AddButton>
          )}

        </QuantityChanger>
        : ''
      )}
    </ProductItem>
  );
};
